import { Grid2 as Grid, styled, Box } from '@mui/material';
import { useShowContext } from 'framework/show';
import LinkIconButtonsEmployeeDashboard from '../../shared/buttons/LinkIconButtonsEmployeeDashboard';
import { BadgeField } from 'framework/ui/field';
import { WorkingStatusChip, EmployeeLinkField, isPolishContractorByEmployeeType } from 'domain/shared/employee';
import EmpoyeeDashboardSpecializationField from '../../shared/fields/EmpoyeeDashboardSpecializationField';
import IssuesEmployeeDashboardFiled from '../../shared/fields/IssuesEmployeeDashboardFiled';
import EmployeeHealthcheckStatus from '../../summary/healthcheck/HealthcheckStatus';
import { DashboardIssuesButtonField, DashboardAssingEmployeeField } from '../../shared/fields';
import { DELEGATED_EMPLOYEE_ZONES_ALIASES } from '../../constants';
import { DashboardEmployee } from '../../types';
import { FollowUpField } from 'domain/shared/core/dashboard';

const StyledGrid = styled(Grid)(() => ({
  fontSize: '12px',
  '.MuiTypography-root': {
    fontSize: '12px',
  },
  '.field__wrapper > .MuiTypography-root': {
    fontSize: '12px',
  },
}));

const EmployeeDashboardItemCollapsed = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const employee = data.getData();
  const isDelegatedZone = employee?.retentionRiskPriority === DELEGATED_EMPLOYEE_ZONES_ALIASES.DELEGATED;
  const isPolishContractor = isPolishContractorByEmployeeType(employee);

  return (
    <Grid
      container
      // TO DO
      className="dashboard-item-content"
      columns={24}
      spacing={1}
      justifyContent="space-between"
      alignItems="center"
    >
      <StyledGrid size={{ xs: 4 }} display="flex">
        <BadgeField
          style={{ display: 'flex', alignItems: 'center' }}
          badges={[<WorkingStatusChip key="working-status" source="employeeStatus" sx={{ ml: 2 }} />]}
        >
          <EmployeeLinkField nameSource="employeeName" source="employeeAlias" label="" isOpenInNewTab />
        </BadgeField>
        <LinkIconButtonsEmployeeDashboard />
      </StyledGrid>

      <StyledGrid size={{ xs: 3 }}>
        <EmpoyeeDashboardSpecializationField />
      </StyledGrid>

      <StyledGrid size={{ xs: 3 }} display="flex" gap={2} justifyContent="space-between">
        <FollowUpField />
      </StyledGrid>

      <StyledGrid size={{ xs: 5 }} display="flex" gap={2} justifyContent="space-between">
        <IssuesEmployeeDashboardFiled />
      </StyledGrid>

      {!isPolishContractor ? (
        <StyledGrid size={{ xs: 2 }}>
          <EmployeeHealthcheckStatus iconSx={{ fontSize: 12 }} />
        </StyledGrid>
      ) : (
        <StyledGrid size={{ xs: 2 }} />
      )}

      <StyledGrid size={{ xs: 4 }}>
        <DashboardAssingEmployeeField />
      </StyledGrid>

      <StyledGrid size={{ xs: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1 }}>
          <DashboardIssuesButtonField availableOnlyForZoneView={isDelegatedZone} />
        </Box>
      </StyledGrid>
    </Grid>
  );
};

export default EmployeeDashboardItemCollapsed;
